// serialize form function
const serializeForm = form => {
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()) {
        obj[key] = formData.get(key);
    }
    return JSON.stringify(obj);
};

// build shopify client
const client = ShopifyBuy.buildClient({
    domain: 'hello-1234568083.myshopify.com',
    storefrontAccessToken: '8279f3c98b21accbd115adf395bc9dbf'
});

let checkout = localStorage.getItem("checkout") ? JSON.parse(localStorage.getItem("checkout")) : [];
if (checkout.length == 0) {
    client.checkout.create().then((cart) => {
        // Do something with the checkout
        checkout = JSON.stringify(cart);
        localStorage.setItem('checkout', checkout); // Store the whole checkout object in localStorage
        var getCheckout = JSON.parse(checkout);
        localStorage.setItem('checkoutId', getCheckout.id); // Store the checkout id in localStorage
    });
}


setTimeout(function() {
    const checkoutId = localStorage.getItem('checkoutId');
    

    // add line item through Buy Now button
    Array.from(document.querySelectorAll('.flash-sale-collection .flash-sale-button')).forEach(function (buybutton) {
        buybutton.addEventListener("click", function(event) {
            var $this = this;
            var formElement = $this.closest('.shopify-product-form');
            var formSerialize = JSON.parse(serializeForm(formElement));
            var variantID = formSerialize.id;
            var quantity = parseInt(formSerialize.quantity);

            const lineItemsToAdd = [
                {
                    variantId: 'gid://shopify/ProductVariant/'+variantID,
                    quantity: quantity
                }
            ];

            // Add an item to the checkout
            client.checkout.addLineItems(checkoutId, lineItemsToAdd).then((checkout) => {
                // Do something with the updated checkout
                localStorage.setItem('checkout', JSON.stringify(checkout)); // update the whole checkout on adding any new line item
                openNav(); 
                client.checkout.fetch(checkoutId).then((checkout) => {
                    // update cart subtotal price
                    var cartSubtotalPrice = checkout.totalPrice.amount;
                    document.querySelector('.cart_total_price').innerHTML = Shopify.formatMoney(cartSubtotalPrice, $('body').data('money-format'));
                    var cartLineItems = checkout.lineItems;
                    var cartHTML = '';
                    var cartqty = 0;
                    Array.from(cartLineItems).forEach(function(lineItem) {
                        var lineItemPrice = lineItem.variant.price.amount;
                        if(lineItem.discountAllocations != '') {
                            var amount = (lineItem.variant.price.amount - lineItem.discountAllocations[0].allocatedAmount.amount).toFixed(2);
                        } else {
                            var amount = lineItem.variant.price.amount;
                            setTimeout(() => {
                                const discountPrice = document.getElementsByClassName("discount_lineitem_price");
                                const linePrice = document.getElementsByClassName("lineitem_price");
                                for(dprice of discountPrice) {
                                    dprice.classList.add('is-hidden'); 
                                }
                                for(lprice of linePrice) {
                                    lprice.classList.remove('compare-at-price'); 
                                }
                            }, 200);
                        }
                        amount = String(amount);

                        var HTML = `<div class="cart__list_item ajax-cart__product media"><figure class="ajax-cart__product-image">`+
                            `<a href="#">`+
                            `<img class="linitem_image" src="${lineItem.variant.image.src}" alt="Nutri Paw" />`+
                            `</a>`+
                            `</figure>`+
                            `<div class="ajax-cart__product-content media-content">`+
                                `<div class="ajax-cart_top-content">`+
                                    `<div class="ajax-cart__information">`+
                                        `<div class="ajax-cart__product-title">`+
                                            `<a href="" class="lineitem_title">${lineItem.title}</a>`+
                                        `</div>`+
                                    `</div>`+
    
                                    `<div class="ajax-cart__price price">`+
                                        `<span class="money sale discount_lineitem_price">${Shopify.formatMoney(amount, $('body').data('money-format'))}</span>`+
                                        `<span class="money compare-at-price lineitem_price">${Shopify.formatMoney(lineItem.variant.price.amount, $('body').data('money-format'))}</span>`+
                                    `</div>`+
                                `</div>`+
            
                                `<div class="ajax-cart_bottom-content">`+
                                    `<div class="ajax-cart__quantity-box product-quantity-box" data-line-item-key={{ forloop.index }}>`+
                                        `<div class="quantity-wrapper quantity-style--box is-medium" data-cart-item-id="${lineItem.id}">`+
                                            `<span class="quantity-minus quantity-element button pagesale_quantity_button is-inverse" data-update-quantity="minus" onclick="updateLineItem('${parseInt(lineItem.quantity - 1)}', '${lineItem.id}')"><span class="icon " data-icon="minus">`+
                                                `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="minus"><rect x="5" y="46" width="90" height="8"/></g></svg>`+
                                            `</span></span>`+
            
                                            `<div class="control quantity-input-control">`+
                                                `<input class="quantity-input quantity-element input" type="number" min="1" size="2" name="quantity" value="${lineItem.quantity}" data-line-id="{{ forloop.index }}">`+
                                            `</div>`+
            
                                            `<span class="quantity-plus quantity-element button pagesale_quantity_button is-inverse" data-update-quantity="plus" onclick="updateLineItem('${parseInt(lineItem.quantity + 1)}', '${lineItem.id}')"><span class="icon " data-icon="plus">`+
                                                `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="plus"><polygon points="95 46 54 46 54 5 46 5 46 46 5 46 5 54 46 54 46 95 54 95 54 54 95 54 95 46"/></g></svg>`+
                                            `</span></span>`+
            
                                        `</div>`+
                                    `</div>`+
            
                                    `<a class="ajax-cart__delete flash_sale_cart__delete" data-cart-item-key="${lineItem.id}" href="#" title="Remove" onclick="removeLineITem('${lineItem.id}')">`+
                                        `<button class="flash_sale_close close" aria-label="close">`+
                                            `<span class="icon-caption">Remove</span>`+
                                        `</button>`+
                                    `</a>`+
                                `</div>`+
            
                            `</div>`+
                        `</div>`;
                        cartHTML = `${cartHTML}${HTML}`;
                        var qty = parseInt(lineItem.quantity);
                        cartqty = cartqty + parseInt(qty);
                    });
                    document.querySelector('.pagesale_cart__list').innerHTML = cartHTML;
                    document.querySelector('.pagesale_cart_count').innerHTML =`${cartqty} Items`;
                });
            });

        });
    });

    // adding discount
    const discountCode = window.flashDiscount.discount;
    console.log(discountCode, '======>discountCode');
    if (discountCode != '') {
        client.checkout.addDiscount(checkoutId, discountCode).then(checkout => {
            // Do something with the updated checkout
            localStorage.setItem('checkout', JSON.stringify(checkout));
            console.log(checkout);
            var cartSubtotalPrice = checkout.totalPrice.amount;
            document.querySelector('.cart_total_price').innerHTML = Shopify.formatMoney(cartSubtotalPrice, $('body').data('money-format'));
            var cartLineItems = checkout.lineItems;
            var cartHTML = '';
            var cartqty = 0;
            Array.from(cartLineItems).forEach(function(lineItem) {
                var lineItemPrice = lineItem.variant.price.amount;
                if(lineItem.discountAllocations != '') {
                    var amount = (lineItem.variant.price.amount - lineItem.discountAllocations[0].allocatedAmount.amount).toFixed(2);
                } else {
                    var amount = lineItem.variant.price.amount;
                    setTimeout(() => {
                        const discountPrice = document.getElementsByClassName("discount_lineitem_price");
                        const linePrice = document.getElementsByClassName("lineitem_price");
                        for(dprice of discountPrice) {
                            dprice.classList.add('is-hidden'); 
                        }
                        for(lprice of linePrice) {
                            lprice.classList.remove('compare-at-price'); 
                        }
                    }, 200);
                }
                amount = String(amount);

                var HTML = `<div class="cart__list_item ajax-cart__product media"><figure class="ajax-cart__product-image">`+
                    `<a href="#">`+
                    `<img class="linitem_image" src="${lineItem.variant.image.src}" alt="Nutri Paw" />`+
                    `</a>`+
                    `</figure>`+
                    `<div class="ajax-cart__product-content media-content">`+
                        `<div class="ajax-cart_top-content">`+
                            `<div class="ajax-cart__information">`+
                                `<div class="ajax-cart__product-title">`+
                                    `<a href="" class="lineitem_title">${lineItem.title}</a>`+
                                `</div>`+
                            `</div>`+
    
                            `<div class="ajax-cart__price price">`+
                                `<span class="money sale discount_lineitem_price">${Shopify.formatMoney(amount, $('body').data('money-format'))}</span>`+
                                `<span class="money compare-at-price lineitem_price">${Shopify.formatMoney(lineItem.variant.price.amount, $('body').data('money-format'))}</span>`+
                            `</div>`+
                        `</div>`+
    
                        `<div class="ajax-cart_bottom-content">`+
                            `<div class="ajax-cart__quantity-box product-quantity-box" data-line-item-key={{ forloop.index }}>`+
                                `<div class="quantity-wrapper quantity-style--box is-medium" data-cart-item-id="${lineItem.id}">`+
                                    `<span class="quantity-minus quantity-element button pagesale_quantity_button is-inverse" data-update-quantity="minus" onclick="updateLineItem('${parseInt(lineItem.quantity - 1)}', '${lineItem.id}')"><span class="icon " data-icon="minus">`+
                                        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="minus"><rect x="5" y="46" width="90" height="8"/></g></svg>`+
                                    `</span></span>`+
    
                                    `<div class="control quantity-input-control">`+
                                        `<input class="quantity-input quantity-element input" type="number" min="1" size="2" name="quantity" value="${lineItem.quantity}" data-line-id="{{ forloop.index }}">`+
                                    `</div>`+
    
                                    `<span class="quantity-plus quantity-element button pagesale_quantity_button is-inverse" data-update-quantity="plus" onclick="updateLineItem('${parseInt(lineItem.quantity + 1)}', '${lineItem.id}')"><span class="icon " data-icon="plus">`+
                                        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="plus"><polygon points="95 46 54 46 54 5 46 5 46 46 5 46 5 54 46 54 46 95 54 95 54 54 95 54 95 46"/></g></svg>`+
                                    `</span></span>`+
    
                                `</div>`+
                            `</div>`+
    
                            `<a class="ajax-cart__delete flash_sale_cart__delete" data-cart-item-key="${lineItem.id}" href="#" title="Remove" onclick="removeLineITem('${lineItem.id}')">`+
                                `<button class="flash_sale_close close" aria-label="close">`+
                                    `<span class="icon-caption">Remove</span>`+
                                `</button>`+
                            `</a>`+
                        `</div>`+
    
                    `</div>`+
                `</div>`;
    
                cartHTML = `${cartHTML}${HTML}`;
                var qty = parseInt(lineItem.quantity);
                cartqty = cartqty + parseInt(qty);
            });
            document.querySelector('.pagesale_cart__list').innerHTML = cartHTML;
            document.querySelector('.pagesale_cart_count').innerHTML =`${cartqty} Items`;
        });
    } else {
        client.checkout.removeDiscount(checkoutId).then(checkout => {
            localStorage.setItem('checkout', JSON.stringify(checkout));
            var cartSubtotalPrice = checkout.totalPrice.amount;
            document.querySelector('.cart_total_price').innerHTML = Shopify.formatMoney(cartSubtotalPrice, $('body').data('money-format'));
            var cartLineItems = checkout.lineItems;
            var cartHTML = '';
            var cartqty = 0;
            Array.from(cartLineItems).forEach(function(lineItem) {
                var lineItemPrice = lineItem.variant.price.amount;
                if(lineItem.discountAllocations != '') {
                    var amount = (lineItem.variant.price.amount - lineItem.discountAllocations[0].allocatedAmount.amount).toFixed(2);
                } else {
                    var amount = lineItem.variant.price.amount;
                    setTimeout(() => {
                        const discountPrice = document.getElementsByClassName("discount_lineitem_price");
                        const linePrice = document.getElementsByClassName("lineitem_price");
                        for(dprice of discountPrice) {
                            dprice.classList.add('is-hidden'); 
                        }
                        for(lprice of linePrice) {
                            lprice.classList.remove('compare-at-price'); 
                        }
                    }, 200);
                }
                amount = String(amount);

                var HTML = `<div class="cart__list_item ajax-cart__product media"><figure class="ajax-cart__product-image">`+
                    `<a href="#">`+
                    `<img class="linitem_image" src="${lineItem.variant.image.src}" alt="Nutri Paw" />`+
                    `</a>`+
                    `</figure>`+
                    `<div class="ajax-cart__product-content media-content">`+
                        `<div class="ajax-cart_top-content">`+
                            `<div class="ajax-cart__information">`+
                                `<div class="ajax-cart__product-title">`+
                                    `<a href="" class="lineitem_title">${lineItem.title}</a>`+
                                `</div>`+
                            `</div>`+
    
                            `<div class="ajax-cart__price price">`+
                                `<span class="money sale discount_lineitem_price">${Shopify.formatMoney(amount, $('body').data('money-format'))}</span>`+
                                `<span class="money compare-at-price lineitem_price">${Shopify.formatMoney(lineItem.variant.price.amount, $('body').data('money-format'))}</span>`+
                            `</div>`+
                        `</div>`+
    
                        `<div class="ajax-cart_bottom-content">`+
                            `<div class="ajax-cart__quantity-box product-quantity-box" data-line-item-key={{ forloop.index }}>`+
                                `<div class="quantity-wrapper quantity-style--box is-medium" data-cart-item-id="${lineItem.id}">`+
                                    `<span class="quantity-minus quantity-element button pagesale_quantity_button is-inverse" data-update-quantity="minus" onclick="updateLineItem('${parseInt(lineItem.quantity - 1)}', '${lineItem.id}')"><span class="icon " data-icon="minus">`+
                                        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="minus"><rect x="5" y="46" width="90" height="8"/></g></svg>`+
                                    `</span></span>`+
    
                                    `<div class="control quantity-input-control">`+
                                        `<input class="quantity-input quantity-element input" type="number" min="1" size="2" name="quantity" value="${lineItem.quantity}" data-line-id="{{ forloop.index }}">`+
                                    `</div>`+
    
                                    `<span class="quantity-plus quantity-element button pagesale_quantity_button is-inverse" data-update-quantity="plus" onclick="updateLineItem('${parseInt(lineItem.quantity + 1)}', '${lineItem.id}')"><span class="icon " data-icon="plus">`+
                                        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="plus"><polygon points="95 46 54 46 54 5 46 5 46 46 5 46 5 54 46 54 46 95 54 95 54 54 95 54 95 46"/></g></svg>`+
                                    `</span></span>`+
    
                                `</div>`+
                            `</div>`+
    
                            `<a class="ajax-cart__delete flash_sale_cart__delete" data-cart-item-key="${lineItem.id}" href="#" title="Remove" onclick="removeLineITem('${lineItem.id}')">`+
                                `<button class="flash_sale_close close" aria-label="close">`+
                                    `<span class="icon-caption">Remove</span>`+
                                `</button>`+
                            `</a>`+
                        `</div>`+
    
                    `</div>`+
                `</div>`;
    
                cartHTML = `${cartHTML}${HTML}`;
                var qty = parseInt(lineItem.quantity);
                cartqty = cartqty + parseInt(qty);
            });
            document.querySelector('.pagesale_cart__list').innerHTML = cartHTML;
            document.querySelector('.pagesale_cart_count').innerHTML =`${cartqty} Items`;
        });
    }

}, 2500);

function redirectCheckout() {
    const checkout = localStorage.getItem("checkout");
    const checkoutId = localStorage.getItem('checkoutId');
    client.checkout.fetch(checkoutId).then((checkout) => {
        var webURL = checkout.webUrl;
        location.href = webURL;
    });
}

function openNav() {
    document.getElementById("myCartSidenav").style.width = "410px";
}

function closeNav() {
    document.getElementById("myCartSidenav").style.width = "0";
}

function removeLineITem(id) {
    const checkoutId = localStorage.getItem('checkoutId');
    const lineItemIdsToRemove = [
        id
    ];

    // Remove an item from the checkout
    client.checkout.removeLineItems(checkoutId, lineItemIdsToRemove).then((checkout) => {
        // Do something with the updated checkout
        localStorage.setItem('checkout', JSON.stringify(checkout));
        var cartSubtotalPrice = checkout.totalPrice.amount;
        document.querySelector('.cart_total_price').innerHTML = Shopify.formatMoney(cartSubtotalPrice, $('body').data('money-format'));
        var cartLineItems = checkout.lineItems;
        var cartHTML = '';
        var cartqty = 0;
        Array.from(cartLineItems).forEach(function(lineItem) {
            var lineItemPrice = lineItem.variant.price.amount;
            if(lineItem.discountAllocations != '') {
                var amount = (lineItem.variant.price.amount - lineItem.discountAllocations[0].allocatedAmount.amount).toFixed(2);
            } else {
                var amount = lineItem.variant.price.amount;
                setTimeout(() => {
                    const discountPrice = document.getElementsByClassName("discount_lineitem_price");
                    const linePrice = document.getElementsByClassName("lineitem_price");
                    for(dprice of discountPrice) {
                        dprice.classList.add('is-hidden'); 
                    }
                    for(lprice of linePrice) {
                        lprice.classList.remove('compare-at-price'); 
                    }
                }, 200);
            }
            amount = String(amount);

            var HTML = `<div class="cart__list_item ajax-cart__product media"><figure class="ajax-cart__product-image">`+
                `<a href="#">`+
                `<img class="linitem_image" src="${lineItem.variant.image.src}" alt="Nutri Paw" />`+
                `</a>`+
                `</figure>`+
                `<div class="ajax-cart__product-content media-content">`+
                    `<div class="ajax-cart_top-content">`+
                        `<div class="ajax-cart__information">`+
                            `<div class="ajax-cart__product-title">`+
                                `<a href="" class="lineitem_title">${lineItem.title}</a>`+
                            `</div>`+
                        `</div>`+
    
                        `<div class="ajax-cart__price price">`+
                            `<span class="money sale discount_lineitem_price">${Shopify.formatMoney(amount, $('body').data('money-format'))}</span>`+
                            `<span class="money compare-at-price lineitem_price">${Shopify.formatMoney(lineItem.variant.price.amount, $('body').data('money-format'))}</span>`+
                        `</div>`+
                    `</div>`+

                    `<div class="ajax-cart_bottom-content">`+
                        `<div class="ajax-cart__quantity-box product-quantity-box" data-line-item-key={{ forloop.index }}>`+
                            `<div class="quantity-wrapper quantity-style--box is-medium" data-cart-item-id="${lineItem.id}">`+
                                `<span class="quantity-minus quantity-element button pagesale_quantity_button is-inverse" data-update-quantity="minus" onclick="updateLineItem('${parseInt(lineItem.quantity - 1)}', '${lineItem.id}')"><span class="icon " data-icon="minus">`+
                                    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="minus"><rect x="5" y="46" width="90" height="8"/></g></svg>`+
                                `</span></span>`+

                                `<div class="control quantity-input-control">`+
                                    `<input class="quantity-input quantity-element input" type="number" min="1" size="2" name="quantity" value="${lineItem.quantity}" data-line-id="{{ forloop.index }}">`+
                                `</div>`+

                                `<span class="quantity-plus quantity-element button pagesale_quantity_button is-inverse" data-update-quantity="plus" onclick="updateLineItem('${parseInt(lineItem.quantity + 1)}', '${lineItem.id}')"><span class="icon " data-icon="plus">`+
                                    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="plus"><polygon points="95 46 54 46 54 5 46 5 46 46 5 46 5 54 46 54 46 95 54 95 54 54 95 54 95 46"/></g></svg>`+
                                `</span></span>`+

                            `</div>`+
                        `</div>`+

                        `<a class="ajax-cart__delete flash_sale_cart__delete" data-cart-item-key="${lineItem.id}" href="#" title="Remove" onclick="removeLineITem('${lineItem.id}')">`+
                            `<button class="flash_sale_close close" aria-label="close">`+
                                `<span class="icon-caption">Remove</span>`+
                            `</button>`+
                        `</a>`+
                    `</div>`+

                `</div>`+
            `</div>`;
            cartHTML = `${cartHTML}${HTML}`;
            var qty = parseInt(lineItem.quantity);
            cartqty = cartqty + parseInt(qty);
        });
        document.querySelector('.pagesale_cart__list').innerHTML = cartHTML;
        document.querySelector('.pagesale_cart_count').innerHTML =`${cartqty} Items`;
    });
}


function updateLineItem(quantity, lineItemID) {
    const checkoutId = localStorage.getItem('checkoutId');
    const lineItemsToUpdate = [
        {
            id: lineItemID, 
            quantity: parseInt(quantity)
        }
    ];

    // Update the line item on the checkout (change the quantity or variant)
    client.checkout.updateLineItems(checkoutId, lineItemsToUpdate).then((checkout) => {
        localStorage.setItem('checkout', JSON.stringify(checkout));
        var cartSubtotalPrice = checkout.totalPrice.amount;
        document.querySelector('.cart_total_price').innerHTML = Shopify.formatMoney(cartSubtotalPrice, $('body').data('money-format'));
        var cartLineItems = checkout.lineItems;
        var cartHTML = '';
        var cartqty = 0;
        Array.from(cartLineItems).forEach(function(lineItem) {
            var lineItemPrice = lineItem.variant.price.amount;
            if(lineItem.discountAllocations != '') {
                var amount = (lineItem.variant.price.amount - lineItem.discountAllocations[0].allocatedAmount.amount).toFixed(2);
            } else {
                var amount = lineItem.variant.price.amount;
                setTimeout(() => {
                    const discountPrice = document.getElementsByClassName("discount_lineitem_price");
                    const linePrice = document.getElementsByClassName("lineitem_price");
                    for(dprice of discountPrice) {
                        dprice.classList.add('is-hidden'); 
                    }
                    for(lprice of linePrice) {
                        lprice.classList.remove('compare-at-price'); 
                    }
                }, 200);
            }
            amount = String(amount);

            var HTML = `<div class="cart__list_item ajax-cart__product media"><figure class="ajax-cart__product-image">`+
                `<a href="#">`+
                `<img class="linitem_image" src="${lineItem.variant.image.src}" alt="Nutri Paw" />`+
                `</a>`+
                `</figure>`+
                `<div class="ajax-cart__product-content media-content">`+
                    `<div class="ajax-cart_top-content">`+
                        `<div class="ajax-cart__information">`+
                            `<div class="ajax-cart__product-title">`+
                                `<a href="" class="lineitem_title">${lineItem.title}</a>`+
                            `</div>`+
                        `</div>`+
    
                        `<div class="ajax-cart__price price">`+
                            `<span class="money sale discount_lineitem_price">${Shopify.formatMoney(amount, $('body').data('money-format'))}</span>`+
                            `<span class="money compare-at-price lineitem_price">${Shopify.formatMoney(lineItem.variant.price.amount, $('body').data('money-format'))}</span>`+
                        `</div>`+
                    `</div>`+

                    `<div class="ajax-cart_bottom-content">`+
                        `<div class="ajax-cart__quantity-box product-quantity-box" data-line-item-key={{ forloop.index }}>`+
                            `<div class="quantity-wrapper quantity-style--box is-medium" data-cart-item-id="${lineItem.id}">`+
                                `<span class="quantity-minus quantity-element button pagesale_quantity_button is-inverse" data-update-quantity="minus" onclick="updateLineItem('${parseInt(lineItem.quantity - 1)}', '${lineItem.id}')"><span class="icon " data-icon="minus">`+
                                    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="minus"><rect x="5" y="46" width="90" height="8"/></g></svg>`+
                                `</span></span>`+

                                `<div class="control quantity-input-control">`+
                                    `<input class="quantity-input quantity-element input" type="number" min="1" size="2" name="quantity" value="${lineItem.quantity}" data-line-id="{{ forloop.index }}">`+
                                `</div>`+

                                `<span class="quantity-plus quantity-element button pagesale_quantity_button is-inverse" data-update-quantity="plus" onclick="updateLineItem('${parseInt(lineItem.quantity + 1)}', '${lineItem.id}')"><span class="icon " data-icon="plus">`+
                                    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="plus"><polygon points="95 46 54 46 54 5 46 5 46 46 5 46 5 54 46 54 46 95 54 95 54 54 95 54 95 46"/></g></svg>`+
                                `</span></span>`+

                            `</div>`+
                        `</div>`+

                        `<a class="ajax-cart__delete flash_sale_cart__delete" data-cart-item-key="${lineItem.id}" href="#" title="Remove" onclick="removeLineITem('${lineItem.id}')">`+
                            `<button class="flash_sale_close close" aria-label="close">`+
                                `<span class="icon-caption">Remove</span>`+
                            `</button>`+
                        `</a>`+
                    `</div>`+

                `</div>`+
            `</div>`;
            cartHTML = `${cartHTML}${HTML}`;
            var qty = parseInt(lineItem.quantity);
            cartqty = cartqty + parseInt(qty);
        });
        document.querySelector('.pagesale_cart__list').innerHTML = cartHTML;
        document.querySelector('.pagesale_cart_count').innerHTML =`${cartqty} Items`;
    });
}

